module.exports = __webpack_public_path__ + "assets/pdf/E15-cn-daily-satellite-monitoring.527c660e.pdf";